// Classic "live" indicator — a solid dot with an expanding, fading ring
// behind it. Used wherever something is actively in progress (e.g. an
// order that's accepted/making/delivery) so it reads as "still moving"
// rather than a static state.
export default function PulseDot({ color = "bg-amber-500", size = "h-2 w-2", className = "" }) {
  return (
    <span className={`relative inline-flex ${size} shrink-0 ${className}`}>
      <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${color} opacity-75`} />
      <span className={`relative inline-flex rounded-full ${size} ${color}`} />
    </span>
  );
}
